import { ConditionRowData } from "../../tables/condition/condition-rows";
import { FeaturedCategory } from "../categories";
import { TableRow } from "../../utils/tables-metadata";

/**
 * Filter chronic and HCC conditions for Featured section
 * This includes conditions marked as either chronic or HCC (or both)
 */
export function getChronicHccConditions(conditions: ConditionRowData[]): ConditionRowData[] {
  return conditions.filter(c => c.isChronic || c.isHcc);
}

export function getFeaturedConditions(): FeaturedCategory {
  return {
    category: "Conditions",
    subCategories: [
      {
        subCategory: "Chronic & HCC",
        tableType: "Condition",
        getRows: (data: TableRow[]) => getChronicHccConditions(data as ConditionRowData[]),
      },
    ],
  };
}
